import React from "react";
import styles from '../components/Exception/index.less';
import {Button} from "antd";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 可以将错误日志上报给服务器
  }

  render() {
    const src= `https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg`;
    if (this.state.hasError) {
      return (
        <div>
        <div className={styles.imgBlock}>
          <center><img src={src} /></center>
        </div>
        <div className={styles.content}>
          <h1><center>抱歉，页面运行出现了一些问题，请稍后重试或尝试其他页面</center></h1>
          <div className={styles}>
            <center><Button onClick={() =>window.location.reload()} >刷新</Button></center>
          </div>
        </div>
      </div>
      );
    }
    return this.props.children;
  }
}
